import { action } from 'typesafe-actions'
import { CourseActionTypes } from './types'
import { ICourse } from '../interface'

export const fetchRequest = (searchParams:any) => {
   //console.log("fetchRequest: " + searchParams.searchTerm);
   return action(CourseActionTypes.FETCH_REQUEST, searchParams);
}

export const fetchSuccess = (data: ICourse[]) => action(CourseActionTypes.FETCH_SUCCESS, data)
export const selectCourse = (id: string) => action(CourseActionTypes.SELECT, id)
export const courseSelected = (data: ICourse) => action(CourseActionTypes.SELECTED, data)
export const fetchError = (message: string) => action(CourseActionTypes.FETCH_ERROR, message)
